export default __webpack_public_path__ + "static/media/Profilepicture.aeb47681.jfif";